import React, { useCallback, useEffect, useRef } from 'react';
import { useDrag } from 'react-dnd';
import _ from 'underscore';
import { Container, Thumbnail, LoaderView, TemplatePageOverview } from './styles';
import { DynamicTableIcon, FooterIcon, HeaderIcon } from '../../images/svgIcons';
import PageNotFoundIllustration from '../../images/generatingPreview.png';
import Loader from '../Loader';
import { getImageDimensions } from '../../utils/javascript';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { correctBaseUrl } from '../../utils/svgUtils';
import { Icon, Tooltip} from 'antd';
import ComplexDocumentHistoryProvider from '../../context/complexDocumentContext';
import ComplexArtboardProvider, { CONTEXT_KEYS, useArtboardContext } from '../../context/complexArtboardContext';
import BusinessLogicProvider from '../../context/businessLogicContext';
import ComplexArtboard from '../../containers/ComplexDocumentDesign/ComplexArtboard';
import { ComplexArtboardWrapper, Wrapper, DocumentContainer } from '../../containers/ComplexDocumentDesign/styles';
import URL from '../../utils/helper';
import { FOOTER, HEADER, COMPLEX_EMAIL, REUSABLE_SECTION } from '../../utils/complexDocumentConstants';
import FontsProvider from '../../context/fontsContext';
import ComplexEmailArtboard from '../../containers/ComplexEmailDesign/ComplexEmailArtboard'
import { useTranslation } from 'react-i18next';
import { DESIGN_AREA_TEMPLATES_TAB } from '../../containers/SidebarMenu/translationValues';
import { HTML_ICON } from '../../images/svgIcons';

const OVERRIDE_ARTBOARD_STATE = {
  [CONTEXT_KEYS.ENABLE_EDITABLE_DESIGN]: false,
  [CONTEXT_KEYS.ENABLE_RULER]: false,
  [CONTEXT_KEYS.RULER_WIDTH_ADJUSTER]:true,
  [CONTEXT_KEYS.DND_FLOW]:true,
  [CONTEXT_KEYS.SCALING_SETTING]: 0.30,
  [CONTEXT_KEYS.CURRENT_DESIGN]:'document'
};

const generateFlowThumbnail = (id) => `${URL.DESIGN_SYSTEM_URL}standalone/flow/thumbnail/${id}`;
const generateBlockThumbnail = (id) => `${URL.DESIGN_SYSTEM_URL}standalone/block/thumbnail/${id}`;

const NAMESPACES = ['DESIGN_AREA_TEMPLATES_TAB'];
const premiumElementsIds = [6, 7, 9];

const EditorElement = ({ element, clickElement, toggleDragging, pageSettings, setIsDragAndDropped, draggable = true,
  loading = false, isSvg = false, docElementTab, type = 'elements', cardType = 'applyTemplate',
  renderDropDown,onPreviewClick, isImage = false, masterVariables, ...props}) => {

  const isOpenDesignSelector = useCallback((store) => store[CONTEXT_KEYS.IS_OPEN_DESIGN], []);
  const [isOpenDesign] = useArtboardContext(isOpenDesignSelector, `EditorElement`);

  const getCurrentDesign = useCallback(store => store[CONTEXT_KEYS.CURRENT_DESIGN], []);
  const [, updateArtboard] = useArtboardContext(getCurrentDesign,`EditorElement`);


  const ref = useRef(undefined);
  const { t } = useTranslation(NAMESPACES);
  let thumbnail = correctBaseUrl(element.thumbnail);
  if (type === "reusableFlow" || type === REUSABLE_SECTION || type === 'header'|| type === 'footer') {
    thumbnail = element.thumbnail ? element.thumbnail : type === 'reusableFlow' ? generateFlowThumbnail(element.id) : generateBlockThumbnail(element.id);
  }
  const isStaticTable = element.name === 'Static Table';
  const isReusableSection = type === REUSABLE_SECTION || type === HEADER || type === FOOTER;

  const getConstructedElement = useCallback((element, details = undefined, template = undefined) => {
    const copiedElement = JSON.parse(JSON.stringify(element));
    if (details) {
      // array of elementDetails (Mostly has width and height for images in the array since
      // they have been dragged and droppped into the design)
      copiedElement.elementDetails = details;
    } else {
      // Single elementDetails
      const { type, styles } = element.elementDetails;
      if ((type === "image" && !(styles.width || styles.height)) || template) { // Uploads tab
        let width = ref.current.naturalWidth;
        let height = ref.current.naturalHeight;
        if (width > pageSettings.size.widthInPX || height > pageSettings.size.heightInPX) {
          let widthRatio = parseInt(width) / (pageSettings.size.widthInPX / 3);
          // Email design area does not have a definite height, hence the height ratio will be the same as width
          let heightRatio = pageSettings.size.heightInPX ? parseInt(height) / (pageSettings.size.heightInPX / 3) : widthRatio;
          const ratio = widthRatio > heightRatio ? widthRatio : heightRatio;
          width = parseInt(width) / ratio; // scale down image width
          height = parseInt(height) / ratio; // scale down image height
        }
        width = `${width}px`;
        height = `${height}px`;
        copiedElement.elementDetails.styles = { ...styles, width, height };
        return copiedElement;
      }
    }
    if (details) {
      return copiedElement;
    }
    return element;
  }, [ref, pageSettings]);

  const [{ isDragging }, drag, preview] = useDrag({
    item: { id: element.id, name: element.name, type, element },
    canDrag: () => {
      if (isOpenDesign && (premiumElementsIds.includes(element.id))) {
        updateArtboard({ [CONTEXT_KEYS.SHOW_SIGNUP_PROMPT]: true });
        return false;
      }
      return draggable;
    },
    begin: (item) => {
      setIsDragAndDropped(true)
      let copiedElement = element;
      console.log('element', element)
      if (element.emailElement || element.isTemplate) {
      } else if (!_.isArray(element.elementDetails) && !element.referenced && element.elementDetails.tagName !== 'block') {
        copiedElement = getConstructedElement(element);
      } else if (_.isArray(element.elementDetails) || element.referenced || element.elementDetails.tagName === 'block') {
        let elementWidth = 0;
        let elementHeight = 0;
        if (element.elementDetails.tagStyles) {
          elementWidth = element.elementDetails.tagStyles.width;
          elementHeight = element.elementDetails.tagStyles.height;
        } else {
          const multipleElements = _.isArray(element.elementDetails) ? element.elementDetails : element.elementDetails.constructedElements;
          const newlyDroppedElements = multipleElements.map(details => getConstructedElement(element, details));
          newlyDroppedElements.forEach(elementDropped => {
            if (
              elementDropped &&
              elementDropped.elementDetails &&
              elementDropped.elementDetails.styles &&
              elementDropped.elementDetails.styles.transform
            ) {
              const transformStyles = elementDropped.elementDetails.styles.transform.split(' ');
              let elementDroppedTransform = {};
              transformStyles.forEach(data => {
                let key = data.split('(')[0];
                let value = data && data.match(/\((.*)\)/)[1];
                value = Number(value.replace(/[^\d.-]/g, ''));
                let pair = { [key]: value };
                elementDroppedTransform = { ...elementDroppedTransform, ...pair };
              });
              if (
                elementDroppedTransform &&
                elementDroppedTransform.translateX.toString() &&
                elementDroppedTransform.translateY.toString() &&
                elementDroppedTransform.rotate.toString()
              ) {
                const calculatedElementWidth =
                  elementDroppedTransform.translateX +
                  Number(elementDropped.elementDetails.styles.width.replace(/px$/, ''));
                const calculatedElementHeight =
                  elementDroppedTransform.translateY +
                  Number(elementDropped.elementDetails.styles.height.replace(/px$/, ''));
                if (calculatedElementWidth > elementWidth) {
                  elementWidth = calculatedElementWidth;
                }
                if (calculatedElementHeight > elementHeight) {
                  elementHeight = calculatedElementHeight;
                }
              }
            }
          });
        }
        copiedElement = JSON.parse(JSON.stringify(element));
        // Calculating the total height and width of the element for preview
        copiedElement.elementDetails.styles = { width: `${elementWidth}px`, height: `${elementHeight}px` }
      } else {
        copiedElement.elementDetails.styles = {};
        copiedElement = getConstructedElement(copiedElement, undefined, true);
      }
      toggleDragging(true);
      return ({
        name: element.name,
        type,
        id: element.id,
        element: copiedElement,
        boundaries: ref.current?.getBoundingClientRect(),
        ...(element.sectionType && {sectionType : element.sectionType})
      });
    },
    end: (item, monitor) => {
      toggleDragging(false);
    },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  useEffect(() => {
    if (!element.icon && !element.emailElement && !element.isTemplate) {
      preview(getEmptyImage(), { captureDraggingState: true });
    }
  }, [preview, element]);

  const opacity = isDragging ? 0.1 : 1;

  const handleElementClick = async () => {
    if (!_.isArray(element.elementDetails)) {
      let { styles, type } = element.elementDetails;
      if (type === 'image' && !(styles.width || styles.height)) {
        let { width, height } = await getImageDimensions(thumbnail);
        let widthRatio = parseInt(width) / (pageSettings.size.widthInPX / 3);
        width = `${parseInt(width) / widthRatio}px`; // scale down image width
        height = `${parseInt(height) / widthRatio}px`; // scale down image height
        styles = { ...styles, width, height };
        element.elementDetails.styles = styles;
      }
    }
    clickElement(element);
  };

  drag(ref);
  if (element.icon) {
    preview(ref);
  }

  const refProps = element.icon ? { ref } : {};

  const iconMap = {
    HTML_ICON: HTML_ICON,
    HeaderIcon: HeaderIcon,
    FooterIcon: FooterIcon,
    DynamicTableIcon: DynamicTableIcon,
  }

  const elementContainer = () => {
    const IconComponent = iconMap[element.icon];
    return (
      <Container className={element.icon && "elementContainer"}
        docElementTab={!element.icon && docElementTab}
        type={element.type}
        style={{ opacity, display: 'flex', alignItems: isStaticTable && 'center', justifyContent: isStaticTable && 'center' }}
        onClick={handleElementClick}
        actionType={element.actionType}
        isTextElement={element?.isText}
        isFillable={element?.isFillable}
        {...refProps}
      >
        {loading && (
          <LoaderView>
            <Loader />
          </LoaderView>
        )}
        {element.icon
          ? (
            <>
              {element?.iconType === 'svg' ? <Icon component={IconComponent} />  : <Icon type={element.icon} />}
              <p>{element.displayName}</p>
            </>
          )
           : (element.isText || element.isFillable) ? (
            <>
              <div
                className="textElement"
                ref={ref}
                dangerouslySetInnerHTML={{ __html: element.thumbnail }}
              />
              {(docElementTab || isStaticTable) && <p className="elementName">{element.name}</p>}
            </>
          ) : (
            <React.Fragment>
              <Thumbnail
                docElementTab={docElementTab}
                ref={ref}
                src={thumbnail ? correctBaseUrl(thumbnail) : PageNotFoundIllustration}
                alt='loading...'
                className={!thumbnail ? 'no-thumbnail' : ''}
              />
              {(docElementTab || isImage) &&
                <p className='elementName'>{element.name}</p>
              }
            </React.Fragment>
          )}
      </Container>
    )
  }

  const handleThumbnailError = (e) => {
    e.target.src = PageNotFoundIllustration;
  }

  const reusableTemplate = () => {
    return (
      <TemplatePageOverview className={element.icon && "elementContainer"}
        onClick={handleElementClick}
        actionType={element.actionType}
        reusableTemplate={true}
        reusableSection= {isReusableSection}
        {...refProps}
      >
        <>
          <div className="template-media">
            <Thumbnail
              reusableTemplate={true}
              reusableSection= {isReusableSection}
              ref={ref}
              src={thumbnail ? correctBaseUrl(thumbnail) : PageNotFoundIllustration}
              alt='loading...'
              className={!thumbnail ? 'no-thumbnail' : ''}
              onError={handleThumbnailError}
            />
            <Tooltip title={t(DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_PREVIEW_TOOLTIP.key, DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_PREVIEW_TOOLTIP.value)} placement="top">
              <div
                className="preview-button"
              onClick={onPreviewClick}
              >
                <Icon type="eye" />
              </div>
            </Tooltip>
            { renderDropDown()}
          </div>
          <div className='template-name'>
            <h2>
              {element.name}
            </h2>
            {props.languageList && !props.isMasterTab && element?.language && (
              <Tooltip title={props.languageList?.find(ln => ln.code === element?.language)?.name} trigger="hover">
                <div className={'language-tag'}>{element?.language}</div>
              </Tooltip>
            )}
          </div>
        </>
      </TemplatePageOverview>
    )
  }

  const DocumentTemplate = () => { 
    return (
      <Wrapper className='wrapperDiv'>
        <ComplexDocumentHistoryProvider masterVariables={masterVariables}>
          <ComplexArtboardProvider documentId={element.id} customState={OVERRIDE_ARTBOARD_STATE} existingDocument={element} customName={"TemplateThumbnailContext"}>
            <BusinessLogicProvider>
              <FontsProvider>
                <ComplexArtboardWrapper>
                  <DocumentContainer className={'environment'}>
                    <ComplexArtboard existingDocument={element} />
                  </DocumentContainer>
                </ComplexArtboardWrapper>
              </FontsProvider>
            </BusinessLogicProvider>
          </ComplexArtboardProvider>
        </ComplexDocumentHistoryProvider>
        </Wrapper>
    )
  }

  const EmailTemplate = () => { 
    return (
      <Wrapper className='wrapperDiv'>
        <ComplexDocumentHistoryProvider masterVariables={masterVariables}>
          <ComplexArtboardProvider documentId={element.id} customState={OVERRIDE_ARTBOARD_STATE} existingDocument={element} customName={"TemplateThumbnailContext"}>
            <BusinessLogicProvider>
              <FontsProvider>
                <ComplexArtboardWrapper>
                  <DocumentContainer className={'environment'}>
                    <ComplexEmailArtboard existingDocument={element} EmailTemplateTab = {true}/>
                  </DocumentContainer>
                </ComplexArtboardWrapper>
              </FontsProvider>
            </BusinessLogicProvider>
          </ComplexArtboardProvider>
        </ComplexDocumentHistoryProvider>
        </Wrapper>
    )
  }

  return (
    <>
      {cardType === "reusableTemplate" ? reusableTemplate() : cardType === 'replaceFlow' ? DocumentTemplate() : cardType === COMPLEX_EMAIL ? EmailTemplate() : elementContainer()}
    </>
  );
};

export default EditorElement;
